import { useState } from 'react';
import { AuthForgotPasswordSection } from '../components/AuthForgotPasswordSection';
import { AuthContactPrompt } from '../components/AuthContactSupport';
import { PageChrome } from '../components/PageChrome';
import { OTHER_SIGN_IN_LOGIN_OPTIONS, type LoginOption } from '../login/loginConstants';
import { translateLoginOption, useI18n } from '../i18n';
import directionStyles from '../components/formInputDirection.module.css';
import credStyles from '../components/AuthCredentialsSection.module.css';
import styles from './AuthRoleLoginPage.module.css';

export type AuthForgotPasswordPageProps = {
  initialLoginType: LoginOption;
  allowLoginTypeChange?: boolean;
  onBack: () => void;
  onContact: () => void;
  onBackToSignIn: () => void;
};

export function AuthForgotPasswordPage({
  initialLoginType,
  allowLoginTypeChange = true,
  onBack,
  onContact,
  onBackToSignIn,
}: AuthForgotPasswordPageProps) {
  const { t } = useI18n();
  const [loginType, setLoginType] = useState<LoginOption>(initialLoginType);
  const showLoginTypePicker = allowLoginTypeChange && OTHER_SIGN_IN_LOGIN_OPTIONS.length > 1;

  return (
    <PageChrome title={t('auth.forgotPassword.title')} onBack={onBack}>
      <div className={styles.page}>
        <p className={styles.intro}>{t('auth.forgotPassword.intro')}</p>
        {showLoginTypePicker ? (
          <div className={`${credStyles.field} ${styles.loginTypeField}`}>
            <label className={credStyles.label} htmlFor="forgot-password-login-type">
              {t('login.loginType')}
            </label>
            <select
              id="forgot-password-login-type"
              className={`${credStyles.select} ${directionStyles.inputLtr}`}
              value={loginType}
              onChange={(event) => setLoginType(event.target.value as LoginOption)}
            >
              {OTHER_SIGN_IN_LOGIN_OPTIONS.map((option) => (
                <option key={option} value={option}>
                  {translateLoginOption(option, t)}
                </option>
              ))}
            </select>
          </div>
        ) : null}
        <AuthForgotPasswordSection loginType={loginType} onBackToSignIn={onBackToSignIn} />
        <footer className={styles.footer}>
          <AuthContactPrompt onContact={onContact} />
        </footer>
      </div>
    </PageChrome>
  );
}
